// Transport-mode filter (Sea / Air / Truck). Pure JS, runs under node --test.
import { modeRowKey } from './modeRows.js';

export const MODE_KEYS = ['sea', 'air', 'truck'];
export const DEFAULT_MODE_KEYS = ['sea', 'air', 'truck'];

/**
 * `mode` URL value -> { mode: 'all' | 'some' | 'none', keys: Set }.
 * Absent (or only unknown tokens) = all three (the default); 'all'; 'none';
 * comma lists, case-insensitive, unknown tokens ignored.
 */
export function parseModeParam(raw) {
  if (raw == null) return { mode: 'all', keys: new Set(DEFAULT_MODE_KEYS) };
  const v = String(raw).trim().toLowerCase();
  if (v === 'all') return { mode: 'all', keys: new Set(MODE_KEYS) };
  if (v === 'none') return { mode: 'none', keys: new Set() };
  const keys = new Set(v.split(',').map((k) => k.trim()).filter((k) => MODE_KEYS.includes(k)));
  if (keys.size === 0) return { mode: 'all', keys: new Set(DEFAULT_MODE_KEYS) };
  if (keys.size === MODE_KEYS.length) return { mode: 'all', keys };
  return { mode: 'some', keys };
}

/** Selected keys -> URL value, or null to drop the param (the default). */
export function serializeModeParam(selected) {
  const sel = MODE_KEYS.filter((k) => selected.includes(k));
  if (sel.length === 0) return 'none';
  if (sel.length === MODE_KEYS.length) return null;
  return sel.join(',');
}

/**
 * The single source for the Arriving 3/7/10 scorecards and the sidebar: the
 * selected modes' rows, each already commodity/country filtered. Sea only
 * returns the sea array itself (same identity, same entries). Air/truck are
 * one row per group id.
 */
export function buildWindowSource(selected, sea, air, truck) {
  const on = new Set(selected);
  const seaRows = on.has('sea') ? sea : [];
  const extra = [];
  const seen = new Set();
  [['air', air], ['truck', truck]].forEach(([m, list]) => {
    if (!on.has(m) || !Array.isArray(list)) return;
    list.forEach((r) => {
      const k = modeRowKey({ transport_mode: m, ...r });
      if (seen.has(k)) return;
      seen.add(k);
      extra.push(r);
    });
  });
  if (!extra.length) return seaRows;
  return [...seaRows, ...extra];
}

/** Count per transport mode of window entries ({ card }). */
export function countByMode(entries) {
  const out = { sea: 0, air: 0, truck: 0 };
  entries.forEach(({ card }) => {
    const m = card?.transport_mode;
    out[m === 'air' || m === 'truck' ? m : 'sea'] += 1;
  });
  return out;
}
